import { ref } from 'vue';
import { secondsToRetry } from './corporationNotReady.js';

/**
 * O estado da tela de espera ("o ata esta sendo preparado para a sua empresa"). Quem liga e o cliente de API (apiClient.js), ao ver o aviso
 * da API; quem mostra e CompanyNotReady.vue, montada no App.vue. Sem Pinia: e uma bandeira so.
 */
export const notReady = ref(false);
export const waitSeconds = ref(15);

export function flagNotReady(error) {
    waitSeconds.value = secondsToRetry(error);
    notReady.value = true;
}
